import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreAuthRoutingModule } from './preAuth-routing.module';

// AM Modules
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'src/app/core/core.module';
import { MatStepperModule } from '@angular/material/stepper';

import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { PassResetComponent } from './pass-reset/pass-reset.component';
import { PlansComponent } from './plans/plans.component';
import { ContactComponent } from './contact/contact.component';
import { ProjectsComponent } from './projects/projects.component';
import { WorldsComponent } from './worlds/worlds.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTabsModule } from '@angular/material/tabs';
import { PrePaymentComponent } from './pre-payment/pre-payment.component';
import { HomeComponent } from './home/home.component';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { ConferenciaCeremoniaComponent } from './conferencia-ceremonia/conferencia-ceremonia.component';
import { FeriaNegociosComponent } from './feria-negocios/feria-negocios.component';
import { FeriaEscolarComponent } from './feria-escolar/feria-escolar.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    PassResetComponent,
    PlansComponent,
    ContactComponent,
    ProjectsComponent,
    WorldsComponent,
    PrePaymentComponent,
    HomeComponent,
    MarketplaceComponent,
    ConferenciaCeremoniaComponent,
    FeriaNegociosComponent,
    FeriaEscolarComponent,
  ],

  imports: [
    FontAwesomeModule,
    CoreModule,
    CommonModule,
    PreAuthRoutingModule,
    MatCardModule,
    MatSliderModule,
    MatDialogModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatIconModule,
    MatCheckboxModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatSnackBarModule,
    FormsModule,
    MatTabsModule,
  ],
})
export class PreAuthModule {}
